export enum VehiclePhotosRoutes {
  vehiclePhotos = 'vehicle-photos',
  condition = 'condition',
  inspections = 'inspections',
  serviceCase = 'service-case',
  documents = 'documents',
}
